import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useTeams } from "../../actions/homeActions";
import CountryNameToCode from "../../js/countryNameToCode";
export default () => {
  const TheATeamColorsData = useSelector(
    (state) => state.app.teamData.teamData
  );
  const { id } = useParams();
  const { data: TheATeamData, isLoading, isError, error } = useTeams(id);
  const code = CountryNameToCode[TheATeamData?.country?.country];
  const flagUrl = code
    ? `https://flagcdn.com/w80/${code.toLowerCase()}.png`
    : null;
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading single team: {error.message}
        </p>
      </div>
    );
  }
  return { isLoading, TheATeamData, TheATeamColorsData, flagUrl };
};
